import { Navigate } from "react-router-dom";
import { RouteObject } from "react-router-dom";
import PageContainer from "base/containers/PageContainer";
import PageLayout from "base/layouts/PageLayout";
import AuthGuard from "base/route-guard/AuthGuard";
import { RecoilRoot } from "recoil";

const moduleRoutes: RouteObject[] = [];
const requireAppRoutes = require.context(
  "/src",
  true,
  /^\.\/.*(?<!Public)Route.tsx$/
);

requireAppRoutes.keys().forEach((path: any) => {
  const route = requireAppRoutes(path).default;
  moduleRoutes.push(route);
});

const routes: RouteObject = {
  path: "/",
  children: [
    {
      path: "/",
      element: (
        <AuthGuard>
          <RecoilRoot>
            <PageContainer>
              <PageLayout />
            </PageContainer>
          </RecoilRoot>
        </AuthGuard>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/dashboard" replace />,
        },
        ...moduleRoutes,
      ],
    },
  ],
};

export default routes;
